import {
  AccountingAward,
  FinalSettlement,
  FinalSettlementPositive,
  FinalSettlementNegative,
  DefinitiveWarrantyRefund,
  Payment,
  FirstPayment
} from '.'
import { SecondPayment } from './Accounting/SecondPayment'

export class Accounting {
    private _accountingAward: AccountingAward | null
    private _finalSettlement: FinalSettlement | null
    private _positiveFinalSettlement: FinalSettlementPositive | null
    private _negativeFinalSettlement: FinalSettlementNegative | null
    private _definitiveWarrantyRefund: DefinitiveWarrantyRefund | null
    private _payment: Payment | null
    private _firstPayment: FirstPayment | null
    private _secondPayment : SecondPayment | null
    private _fraccionaPago : boolean
    private _danos : boolean

    constructor (
      accountingAward: AccountingAward | null,
      finalSettlement: FinalSettlement | null,
      positiveFinalSettlement: FinalSettlementPositive | null,
      negativeFinalSettlement: FinalSettlementNegative | null,
      definitiveWarrantyRefund: DefinitiveWarrantyRefund | null,
      payment: Payment | null,
      firstPayment: FirstPayment | null,
      secondPayment: SecondPayment | null,
      fraccionPago: boolean,
      danos: boolean
    ) {
      this._accountingAward = accountingAward
      this._finalSettlement = finalSettlement
      this._positiveFinalSettlement = positiveFinalSettlement
      this._negativeFinalSettlement = negativeFinalSettlement
      this._definitiveWarrantyRefund = definitiveWarrantyRefund
      this._payment = payment
      this._firstPayment = firstPayment
      this._secondPayment = secondPayment
      this._fraccionaPago = fraccionPago
      this._danos = danos
    }

    get award (): AccountingAward | null {
      return this._accountingAward
    }

    public setAward (award: AccountingAward): void {
      this._accountingAward = award
    }

    get finalSettlement (): FinalSettlement | null {
      return this._finalSettlement
    }

    public setFinalSettlement (finalSettlement: FinalSettlement): void {
      this._finalSettlement = finalSettlement
    }

    get positiveFinalSettlement (): FinalSettlementPositive | null {
      return this._positiveFinalSettlement
    }

    public setPositiveFinalSettlement (positiveFinalSettlement: FinalSettlementPositive): void {
      this._positiveFinalSettlement = positiveFinalSettlement
    }

    get negativeFinalSettlement (): FinalSettlementNegative | null {
      return this._negativeFinalSettlement
    }

    public setNegativeFinalSettlement (negativeFinalSettlement: FinalSettlementNegative): void {
      this._negativeFinalSettlement = negativeFinalSettlement
    }

    get definitiveWarrantyRefund (): DefinitiveWarrantyRefund | null {
      return this._definitiveWarrantyRefund
    }

    public setDefinitiveWarrantyRefund (definitiveWarrantyRefund: DefinitiveWarrantyRefund): void {
      this._definitiveWarrantyRefund = definitiveWarrantyRefund
    }

    get payment (): Payment | null {
      return this._payment
    }

    public setPayment (payment: Payment): void {
      this._payment = payment
    }

    get firstPayment (): FirstPayment | null {
      return this._firstPayment
    }

    public setFirstPayment (firstPayment: FirstPayment): void {
      this._firstPayment = firstPayment
    }

    get secondPayment (): SecondPayment | null {
      return this._secondPayment
    }

    get fraccionaPago (): boolean {
      return this._fraccionaPago
    }

    get danos (): boolean {
      return this._danos
    }

    public setSecondPayment (secondPayment: SecondPayment): void {
      this._secondPayment = secondPayment
    }
}
